/**
 * @private
 */
export const syncCollectionName = 'kinvey_sync';

/**
 * @private
 */
export const maxEntityLimit = 10000;

/**
 * @private
 */
export const defaultPullSortField = '_kmd.ect';



// WEBPACK FOOTER //
// /home/travis/build/Kinvey/js-sdk/src/core/datastore/sync/utils.js